import HealthCheckResposta from '../util/HealthCheckResposta';
import Service from './Service';

/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class HealthCheckService extends Service {
    carregaVariaveisAmbiente() {
        return this.getHealthCheckApi().getVariaveis();
    }

    async verificarBackends() {
        let backends = [];

        let sessao;
        try {
            sessao = await this.getHealthCheckApi().backendSessao();
        } catch (e) {
            console.error(e);
            sessao = {
                info: {
                    nomeApp: 'Backend Sessão',
                    versaoApp: 'Desconhecido'
                },
                status: {
                    tipo: HealthCheckResposta.STATUS_ERRO
                }
            };
        }
        backends.push(sessao);

        return backends;
    }
}

export default HealthCheckService;
